import { render, staticRenderFns } from "./TemplateGroupCard.vue?vue&type=template&id=04d184a4&scoped=true"
import script from "./TemplateGroupCard.vue?vue&type=script&lang=js"
export * from "./TemplateGroupCard.vue?vue&type=script&lang=js"
import style0 from "./TemplateGroupCard.vue?vue&type=style&index=0&id=04d184a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d184a4",
  null
  
)

export default component.exports